import React, { useEffect, useState } from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { ButtonGroup, Row, Col, Button } from "react-bootstrap";
import {
  customStyles,
  HELP_PAGE_EXTENSION,
  HOST_URL,
} from "../../helpers/constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import {
  addLegacyProject,
  addProject,
  fetchDrawingSets,
  fetchMviewRegions,
  fetchProjectUserDetails,
  getAllProjectReviews,
  getAllProjectUsers,
  getAllSubmittals,
  getAllSurveys,
  getProjectAssetTasks,
  getRegionStatuses,
} from "../../helpers/axios/projectsAxios";
import {
  ACC_DRAWING_SETS,
  ACC_SHEETS,
  ALL_ASSETS,
  ALL_DOCS,
  ALL_PROJECT_REVIEWS,
  ALL_PROJECT_SUBMITTALS,
  ALL_PROJECT_USERS,
  ALL_REGIONS,
  ALL_SURVEYS,
  AUTH_TIMER,
  CLOUD_FILES,
  LEGACY_MODELS,
  PROJECT_CHANGE_LOADING,
  REGIONAL_STATUSES,
  SELECTED_PROJECT,
  SHOW_TOAST,
  TOAST_BODY,
  TOAST_TITLE,
  updateGlobalState,
  USER_DETAILS,
} from "../../helpers/reducers/GlobalReducer";
import { getForgeToken } from "../../helpers/actions/RequestData";
import {
  LAUNCH_VIEWER,
  MODEL_DATA,
  MODEL_DATA_LOADED,
  MODEL_FILTER_STATE,
  SELECTED_DRAWING_SET,
  SELECTED_MODELS,
  SELECTED_OBJECT_DATA,
  SELECTED_SHEET,
  SHEETS_SELECTED,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";
import {
  SELECTED_ICON,
  SELECTED_TREE_ITEMS,
  updateNavigationState,
} from "../../helpers/reducers/NavigationReducer";
import { getAllRegionAssets } from "../../helpers/axios/assetsAxios";
/* global Autodesk, THREE */ // eslint-disable-line

const AccProjectSelect = (props) => {
  const SELECT_LABEL_MAX_LENGTH = 35;

  const { projectList, selectedProject, projectChangeLoading } = useSelector(
    (state) => state.globalReducer,
  );
  const userData = useSelector((state) => state.userData);

  const [modelErrorModal, setModelErrorModal] = useState(false);
  const [incorrectAccModels, setIncorrectAccModels] = useState([]);
  const dispatch = useDispatch();

  let newProjectList;

  const truncateSelectLabel = (label, maxLength = SELECT_LABEL_MAX_LENGTH) => {
    if (!label || label.length <= maxLength) return label;
    return `${label.slice(0, maxLength).trimEnd()}...`;
  };

  const CustomSingleValue = (singleValueProps) => {
    const { children } = singleValueProps;

    return (
      <components.SingleValue {...singleValueProps}>
        {truncateSelectLabel(children)}
      </components.SingleValue>
    );
  };

  // useEffect(() => {
  //   axios
  //     .get(PROJECTDATA_URL, {
  //       withCredentials: true,
  //       params: {
  //         type: "projects",
  //         hubId: HUB_ID,
  //       },
  //     })
  //     .then((data) => {
  //       const sortedData = data.data.sort((a, b) =>
  //         a.text.localeCompare(b.text),
  //       );
  //       dispatch(
  //         updateGlobalState({
  //           value: sortedData,
  //           stateName: PROJECT_LIST,
  //         }),
  //       );
  //     })
  //     .catch(console.log);
  // }, []);

  useEffect(() => {
    if (selectedProject[0]?.mviewProjectInfo) {
      projectChangeHandler();
    }
    // projectChangeHandler is intentionally triggered by selectedProject changes only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject]);

  const projectChangeHandler = async () => {
    dispatch(
      updateGlobalState({
        value: true,
        stateName: PROJECT_CHANGE_LOADING,
      }),
    );

    const updateTimer = (expiry) => {
      dispatch(
        updateGlobalState({
          value: expiry,
          stateName: AUTH_TIMER,
        }),
      );
    };

    dispatch(
      updateModelState({
        value: null,
        stateName: SELECTED_OBJECT_DATA,
      }),
    );
    dispatch(
      updateModelState({
        value: false,
        stateName: SHEETS_SELECTED,
      }),
    );
    dispatch(
      updateModelState({
        value: null,
        stateName: SELECTED_SHEET,
      }),
    );
    dispatch(
      updateModelState({
        value: false,
        stateName: LAUNCH_VIEWER,
      }),
    );
    dispatch(
      updateNavigationState({
        value: [],
        stateName: SELECTED_TREE_ITEMS,
      }),
    );
    dispatch(
      updateModelState({
        value: null,
        stateName: SELECTED_DRAWING_SET,
      }),
    );
    getForgeToken(() => {}, updateTimer);
    dispatch(
      updateModelState({
        value: null,
        stateName: MODEL_DATA,
      }),
    );
    dispatch(
      updateModelState({
        value: false,
        stateName: MODEL_DATA_LOADED,
      }),
    );
    if (window.location.href.includes("viewer")) {
      const mviewInfo = selectedProject[0].mviewProjectInfo;
      if (mviewInfo.projectCode === "legacy") {
        dispatch(
          updateNavigationState({
            value: "Legacy Browser",
            stateName: SELECTED_ICON,
          }),
        );
      } else if (mviewInfo.projectSetup) {
        dispatch(
          updateNavigationState({
            value: "File Browser",
            stateName: SELECTED_ICON,
          }),
        );
      } else {
        dispatch(
          updateNavigationState({
            value: "ProjectSetup",
            stateName: SELECTED_ICON,
          }),
        );
      }
    }
    if (window.location.href.includes("settings")) {
      dispatch(
        updateNavigationState({
          value: "Users",
          stateName: SELECTED_ICON,
        }),
      );
    }
    try {
      await Promise.all([
        fetchStatuses(selectedProject[0]?.mviewProjectInfo?.regionCode),
        fetchAssetData(
          selectedProject[0]?.mviewProjectInfo?.regionCode,
          selectedProject[0]?.mviewProjectInfo?.assetFilterKey,
        ),
        fetchSurveys(selectedProject[0]?.mviewProjectInfo?.regionCode),
      ]);
      dispatch(
        updateModelState({
          value: false,
          stateName: MODEL_DATA_LOADED,
        }),
      );

      const projectUserDetails = await fetchProjectUserDetails(
        selectedProject[0].id,
        userData.data.emailId,
      );
      dispatch(
        updateGlobalState({
          value: projectUserDetails,
          stateName: USER_DETAILS,
        }),
      );
      if (selectedProject[0]?.projectCode === "legacy") {
        await Promise.all([
          fetchLegacyModels(selectedProject[0].id),
          fetchAllProjectUsers(selectedProject[0].id),
        ]);
      } else {
        const tempMviewDocs = await fetchAllDocs(selectedProject[0].id);
        const values = await Promise.all([
          fetchAllSubmittals(selectedProject[0].id),
          fetchAllProjectReviews(selectedProject[0].id),
          fetchCloudModels(selectedProject[0].id),
          fetchAllProjectUsers(selectedProject[0].id),
          fetchAccDrawingSets(selectedProject[0].id),
        ]);
        checkForIncorrectFiles(tempMviewDocs, values[2]);
      }
    } finally {
      dispatch(
        updateGlobalState({
          value: false,
          stateName: PROJECT_CHANGE_LOADING,
        }),
      );
    }
    // await fetchAllSubmittals(selectedProject[0].id);
    // await fetchAllProjectReviews(selectedProject[0].id);
    // await fetchCloudModels(selectedProject[0].id);
    // await fetchAllProjectUsers(selectedProject[0].id);
    // await fetchAccDrawingSets(selectedProject[0].id);
  };

  const projectSelectHandler = async (e) => {
    if (!e?.value?.[0] || projectChangeLoading) {
      return;
    }

    let handoffToProjectChange = false;

    dispatch(
      updateGlobalState({
        value: true,
        stateName: PROJECT_CHANGE_LOADING,
      }),
    );

    //check db to see if project already exists
    dispatch(
      updateModelState({
        value: [],
        stateName: SELECTED_MODELS,
      }),
    );
    dispatch(
      updateGlobalState({
        value: [],
        stateName: ACC_SHEETS,
      }),
    );

    dispatch(
      updateModelState({
        value: { process: null, status: null, discipline: null },
        stateName: MODEL_FILTER_STATE,
      }),
    );

    try {
      let projectCode;
      // const exists = await axios.get(HOST_URL + "/projects/checkProject", {
      //   withCredentials: true,
      //   params: { projectAccId: e.value[0].id },
      // });
      const exists = await axios({
        method: "get",
        url: HOST_URL + "/projects/checkProject",
        withCredentials: true,
        params: {
          projectAccId:
            e.value[0].id.split("/")[e.value[0].id.split("/").length - 1],
        },
      });
      //if exists skip over project code definition but use code from db to add to redux
      if (exists.data.exists) {
        handoffToProjectChange = true;

        if (e.value[0].mviewProjectType === "Legacy") {
          const temp = [
            {
              ...e.value[0],
              id: e.value[0].id.split("/")[e.value[0].id.split("/").length - 1],
              mviewProjectInfo: { ...exists?.data.mviewProject },
              projectCode: "legacy",
            },
          ];
          dispatch(
            updateGlobalState({
              value: temp,
              stateName: SELECTED_PROJECT,
            }),
          );
          return;
        }

        projectCode = exists.data.mviewProject.projectCode;

        const temp = [
          {
            ...e.value[0],
            id: e.value[0].id.split("/")[e.value[0].id.split("/").length - 1],
            mviewProjectInfo: { ...exists?.data.mviewProject },
            projectCode: projectCode,
          },
        ];
        dispatch(
          updateGlobalState({
            value: temp,
            stateName: SELECTED_PROJECT,
          }),
        );
        return;
      }

      if (e.value[0].mviewProjectType === "Legacy") {
        const tempProjectInfo = {
          ...e.value[0],
          id: e.value[0].id.split("/")[e.value[0].id.split("/").length - 1],
          mviewProjectInfo: null,
          projectCode: "legacy",
        };
        // await addProject([tempProjectInfo]);
        await addLegacyProject([tempProjectInfo]);
        dispatch(
          updateGlobalState({
            value: [tempProjectInfo],
            stateName: SELECTED_PROJECT,
          }),
        );
        // await fetchCloudModels(tempProjectInfo?.id); //Change this to new function for fetching models from legacy projects.
        return;
      }
      await fetchAllRegions();

      const temp = {
        ...e.value[0],
        id: e.value[0].id.split("/")[e.value[0].id.split("/").length - 1],
        mviewProjectInfo: null,
      };

      await addProject([temp]);
      dispatch(
        updateGlobalState({
          value: [temp],
          stateName: SELECTED_PROJECT,
        }),
      );

      // setProjectInfo(temp);
      // setProjectSetupModal(true);
      // completeProjectSetup(temp);
    } finally {
      if (!handoffToProjectChange) {
        dispatch(
          updateGlobalState({
            value: false,
            stateName: PROJECT_CHANGE_LOADING,
          }),
        );
      }
    }
  };

  const checkForIncorrectFiles = (mviewDocs, accDocs) => {
    if (mviewDocs.length === 0 || accDocs.length === 0) return;
    const mviewFileNames = mviewDocs.map((doc) => {
      return doc.docNumber;
    });
    let filteredAccDocs = [];
    if (accDocs?.message !== "No models created yet") {
      filteredAccDocs = accDocs.filter(
        (doc) =>
          !mviewFileNames.includes(doc.attributes.displayName.split(".")[0]),
      );
    }
    if (
      filteredAccDocs.length > 0 &&
      !window.location.href.includes("settings")
    )
      setModelErrorModal(true);
    // window.alert(
    //   `There are some models that have been uploaded to ACC that do not match naming conventions from mView project config:${filteredAccDocs.forEach(
    //     (doc) => doc.attributes.displayName
    //   )}`
    //   filteredAccDocs.forEach((doc) => {
    //     return `- ${doc.attributes.displayName}`
    //   })
    // );
    setIncorrectAccModels(filteredAccDocs);
  };

  const fetchAllSubmittals = async (projectId) => {
    const data = await getAllSubmittals(projectId);
    dispatch(
      updateGlobalState({
        value: data,
        stateName: ALL_PROJECT_SUBMITTALS,
      }),
    );
  };

  const fetchAllProjectReviews = async (projectId) => {
    const data = await getAllProjectReviews(projectId);
    dispatch(
      updateGlobalState({
        value: data,
        stateName: ALL_PROJECT_REVIEWS,
      }),
    );
  };

  const fetchLegacyModels = async (projectId) => {
    const data = await axios.get(HOST_URL + "/forgeData/getLegacyModels", {
      withCredentials: true,
      params: {
        projectId,
      },
    });
    if (!data.data.message) {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: CLOUD_FILES,
        }),
      );
      dispatch(
        updateGlobalState({
          value: data.data,
          stateName: LEGACY_MODELS,
        }),
      );
    } else {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: CLOUD_FILES,
        }),
      );
      dispatch(
        updateGlobalState({
          value: [],
          stateName: LEGACY_MODELS,
        }),
      );
    }
    return data.data;
  };

  const fetchCloudModels = async (projectId) => {
    const data = await axios.get(HOST_URL + "/forgeData/getCloudModels", {
      withCredentials: true,
      params: {
        projectId,
      },
    });
    if (!data.data.message) {
      const modelsProcessing = data.data.filter(
        (file) =>
          file.attributes.extension.data.processState !== "PROCESSING_COMPLETE",
      );
      const modelsReady = data.data.filter(
        (file) =>
          file.attributes.extension.data.processState === "PROCESSING_COMPLETE",
      );
      if (modelsProcessing.length > 0) {
        dispatch(
          updateGlobalState({
            value: "Model Processing",
            stateName: TOAST_TITLE,
          }),
        );

        dispatch(
          updateGlobalState({
            value: `${modelsProcessing.length} model(s) are still processing in ACC. They will be available once processing is complete. You will just need to reload the viewer.`,
            stateName: TOAST_BODY,
          }),
        );

        dispatch(
          updateGlobalState({
            value: true,
            stateName: SHOW_TOAST,
          }),
        );
      }
      dispatch(
        updateGlobalState({
          value: [],
          stateName: LEGACY_MODELS,
        }),
      );
      dispatch(
        updateGlobalState({
          value: modelsReady,
          stateName: CLOUD_FILES,
        }),
      );
    } else {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: LEGACY_MODELS,
        }),
      );
      dispatch(
        updateGlobalState({
          value: [],
          stateName: CLOUD_FILES,
        }),
      );
    }
    return data.data;
  };

  const fetchAllRegions = async () => {
    const tempRegions = await fetchMviewRegions();

    dispatch(
      updateGlobalState({
        value: tempRegions.data,
        stateName: ALL_REGIONS,
      }),
    );
  };

  const fetchAccDrawingSets = async (projectId) => {
    const tempDrawingSets = await fetchDrawingSets(projectId);
    dispatch(
      updateGlobalState({
        value: tempDrawingSets.data,
        stateName: ACC_DRAWING_SETS,
      }),
    );
  };

  const fetchStatuses = async (regionCode) => {
    if (!regionCode) {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: REGIONAL_STATUSES,
        }),
      );
      return;
    }
    const data = await getRegionStatuses(regionCode);
    dispatch(
      updateGlobalState({
        value: data,
        stateName: REGIONAL_STATUSES,
      }),
    );
  };

  const fetchSurveys = async (regionCode) => {
    if (!regionCode) {
      dispatch(
        updateGlobalState({
          value: [],
          stateName: ALL_SURVEYS,
        }),
      );
      return;
    }
    const data = await getAllSurveys(regionCode);

    dispatch(
      updateGlobalState({
        value: data,
        stateName: ALL_SURVEYS,
      }),
    );
  };

  const fetchAssetData = async (regionCode, assetFilterKey) => {
    if (!regionCode) {
      // console.warn("Region code or site type is not defined.");
      return;
    }
    const tempAssets = await getAllRegionAssets(regionCode, assetFilterKey);

    const sortedData = tempAssets.sort((a, b) => a.name.localeCompare(b.name));
    dispatch(
      updateGlobalState({
        value: sortedData,
        stateName: ALL_ASSETS,
      }),
    );
  };

  const fetchAllDocs = async (projectId) => {
    const allDocs = await getProjectAssetTasks(projectId);
    const docsArray = Array.isArray(allDocs) ? allDocs : [];
    const sortedData = docsArray.sort((a, b) =>
      a.docNumber.localeCompare(b.docNumber),
    );
    dispatch(
      updateGlobalState({
        value: sortedData,
        stateName: ALL_DOCS,
      }),
    );
    return sortedData;
  };

  const fetchAllProjectUsers = async (projectId) => {
    const allProjectUsers = await getAllProjectUsers(projectId);
    if (allProjectUsers.message !== "No users could be found.") {
      const sortedData = allProjectUsers.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      dispatch(
        updateGlobalState({
          value: sortedData,
          stateName: ALL_PROJECT_USERS,
        }),
      );
    }
  };

  if (projectList) {
    newProjectList = projectList.map((project) => {
      return {
        value: [project],
        label: project.text,
      };
    });
  }

  // const onCloseModal = () => {
  //   // setProjectSetupModal(false);
  //   // setProjectInfo();
  // };

  // useEffect(() => {
  //   if (modelDataLoaded && viewerApp) {
  //     // viewerApp.uninitialize();
  //     viewerApp.finish();
  //   }
  // }, [modelDataLoaded, viewerApp]);

  return (
    <>
      {/* {!modelDataLoaded && (
      )} */}
      <div
        id="viewerDivProject"
        style={{
          position: "absolute",
          height: "1%",
          width: "1%",
          zIndex: "-1",
          top: "-100px",
        }}
      />
      {window?.location?.pathname !== HELP_PAGE_EXTENSION &&
      window?.location?.pathname !== "/home" &&
      window?.location?.pathname !== "/personalhub" ? (
        <div
          className="acc-project-select-wrap"
          style={{
            margin: "auto",
            padding: "10px",
            width: "clamp(240px, 30vw, 350px)",
          }}
        >
          <Select
            className="acc-project-select"
            classNamePrefix="acc-project-select"
            placeholder="Please select a project"
            options={newProjectList}
            isSearchable={true}
            isDisabled={projectChangeLoading}
            styles={customStyles}
            components={{ SingleValue: CustomSingleValue }}
            onChange={projectSelectHandler}
            value={
              selectedProject
                ? { value: selectedProject, label: selectedProject[0].text }
                : {
                    value: "Please select a project.",
                    label: "Please select a project.",
                  }
            }
          />
          {/* MODALS */}
          <Modal
            show={modelErrorModal}
            onHide={() => setModelErrorModal(false)}
            dialogClassName="project-info-modal model-error-modal"
            centered
          >
            <Modal.Header className="project-info-modal__header model-error-modal__header">
              <Modal.Title>Model Naming Error</Modal.Title>
              <div
                data-bs-theme="dark"
                style={{
                  position: "absolute",
                  right: 20,
                }}
              >
                <button
                  type="button"
                  className="btn-close project-info-modal__close"
                  onClick={() => setModelErrorModal(false)}
                  aria-label="Close"
                />
              </div>
            </Modal.Header>
            <Modal.Body className="project-info-modal__body model-error-modal__body">
              <div className="row">
                <div className="col">
                  <p className="model-error-modal__copy">
                    There are some models that have been uploaded into the "05 -
                    Models" folder in ACC that do not match naming conventions
                    from mView project config.
                  </p>
                  <p className="model-error-modal__copy">
                    These files will not be viewable within the model viewer,
                    please correct this with the CAD technician:
                  </p>
                  <ul className="model-error-modal__list">
                    {incorrectAccModels.map((model, i) => {
                      return (
                        <li key={i}>{`${model.attributes.displayName} - ${
                          model.description
                            ? model.description
                            : "No description"
                        }`}</li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <Row>
                <Col>
                  <ButtonGroup className="model-error-modal__actions">
                    <Button
                      variant="outline-success"
                      size="sm"
                      className="project-status-modal__action-btn model-error-modal__action-btn"
                      onClick={() => setModelErrorModal(false)}
                      // disabled={
                      //   !projectInfo?.projectRegion || !projectInfo?.projectCode
                      // }
                    >
                      OK
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default AccProjectSelect;
